import {Injectable, OnDestroy} from '@angular/core';
import {Dictionary} from "../../../../../shared/utils";
import {Order} from "../../models/order";
import {difference} from "lodash";

class OrderDictionary {
  searchFor: Dictionary<Order> = {}

  toList(): Order[] {
    return Object.values(this.searchFor);
  }

  clean(): void {
    this.searchFor = {};
  }
}

@Injectable()
export class OrdersDictionaryService {
  private orderQueue: OrderDictionary;

  constructor() {
    this.orderQueue = new OrderDictionary();
  }

  private static addToDictionary(dic: OrderDictionary, orders: Order[]) {
    for (const order of orders) {
      dic.searchFor[order.code] = order;
    }
  }

  private static removeFormDictionary(dic: OrderDictionary, orders: Order[]) {
    for (const order of orders) {
      delete dic.searchFor[order.code];
    }
  }

  public enqueueOrders(orders: Order[]): { added: number[], removed: number[]} {
    const queueIds = this.orderQueue.toList().map(o => o.id);
    const arrayIds = orders.map(o => o.id);
    const toRemove = difference(queueIds, arrayIds);
    const toAdd = difference(arrayIds, queueIds);

    OrdersDictionaryService.removeFormDictionary(this.orderQueue, orders.filter(o => toRemove.includes(o.id)));
    OrdersDictionaryService.addToDictionary(this.orderQueue, orders.filter(o => toAdd.includes(o.id)));

    return { added: toAdd, removed: toRemove };
  }

  public dequeueOrders(orders: Order[]) {
    this.orderQueue.clean();
  }

  public get Orders(): Order[] {
    return this.orderQueue.toList();
  }
}
